/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-underscore-dangle */
import { Icon } from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { useTranslator } from '@jutro/locale';
import { ErrorLevel } from '@xengage/gw-portals-edge-validation-js';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import classNames from 'classnames';
import _ from 'lodash';
import React, { useContext } from 'react';
import styles from './TFPAWizardSideMenu.module.scss';
import wizardMessages from '../../common/TFPAWizardMessages.messages.js';


/**
 * @typedef {import('@xengage/gw-portals-edge-validation-js/errors').GenericUIIssue} GenericUIIssue
 */

/**
 * Renders an icon for steps with errors
 * @param {Array<GenericUIIssue>} errorsAndWarnings array
 * @returns {Object}
 */
function renderErrors(errorsAndWarnings = []) {
    const highestLevel = errorsAndWarnings
        .map(err => err.level)
        .reduce((currentHighest, currentError) => {
            if (!currentHighest) {
                return currentError;
            }

            if (currentHighest === ErrorLevel.LEVEL_WARN) {
                // currentError can only Greater or Equal than currentHighest
                return currentError;
            }

            return currentHighest;
        }, null);

    switch (highestLevel) {
        case ErrorLevel.LEVEL_ERROR:
            return (
                <Icon
                    icon="mi-remove_circle_outline"
                    className={styles.errorIssue}
                />
            );
        case ErrorLevel.LEVEL_WARN:
            return <Icon icon="mi-warning" className={styles.warningIssue} />;
        default:
            return null;
    }
}

async function jumpRenderModal(
    index,
    wizardContext,
    isFnolWizard
) {
    const modalMessages = {
        title: wizardMessages.TWIAWizardModalTitle,
        message: wizardMessages.TWIAWizardModalMessage,
        status: 'warning',
        icon: 'mi-error-outline',
        confirmButtonText: wizardMessages.TWIAWizardModalConfirm,
        cancelButtonText: wizardMessages.TWIAWizardModalCancel,
        className: styles.jut__Button__filled,
    };
    const { showConfirm, jumpTo, wizardData, wizardSnapshot, onPageJump } = wizardContext;

    if (isFnolWizard) {
        const fnolModalMsgs = {
            ...modalMessages,
            messageProps: {
                ok: wizardMessages.TWIAWizardModalConfirm,
                close: wizardMessages.TWIAWizardModalCancel,
            },
        };

        const result = await showConfirm(fnolModalMsgs);

        if (result === 'confirm') {
            jumpTo(index)
        }

        
    } else {

        const result = await showConfirm(modalMessages);

        if (result === 'confirm') {
            jumpTo(index)
        }
    }

}

function renderSteps(
    translator,
    steps,
    currentStepIndex,
    stepsWithErrors,
    jumpTo,
    wizardContext,
    isFnolWizard
) {
    return steps.map((step, index) => {
        const liClassName = classNames(styles.step, {
            [styles.active]: index === currentStepIndex,
            [styles.notVisited]: currentStepIndex < index,
        });

        return (
            <li className={liClassName} key={step.id}>
                <button
                    className={styles.navigationButton}
                    onClick={() => currentStepIndex > index &&
                        jumpRenderModal(
                            index,
                            wizardContext,
                            isFnolWizard
                        )
                    }
                    type="button"
                >
                    {translator(step.title)}
                    {renderErrors(stepsWithErrors[step.id])}
                </button>
            </li>
        );
    });
}

function renderMobileSteps(translator,
    steps,
    currentStepIndex,
    stepsWithErrors,
    jumpTo,
    wizardContext,
    authHeader,
    isFnolWizard) {
    const shouldHideStep = wizardContext?.wizardData?.value?.baseData?.periodStatus === 'Submitted_Ext';
    const updatedSteps = shouldHideStep ? steps.filter(step => step.id === 'PaymentDetailsPage' || step.id === 'PaymentDetails') : steps

    return updatedSteps.map((step, index) => {
        const liClassName = classNames(styles.mobileStep, {
            [styles.active]: index === currentStepIndex,
            [styles.notVisited]: currentStepIndex < index,
        });

        return (
            <li className={liClassName} key={step.id} title={translator(step.title)}
                onClick={() => currentStepIndex > index &&
                    jumpRenderModal(
                        index,
                        wizardContext,
                        updatedSteps,
                        authHeader,
                        currentStepIndex,
                        isFnolWizard
                    )
                }
            />
        );
    });
}

function TFPAWizardSideMenu({ title }) {
    const wizardContext = useContext(WizardContext);

    const translator = useTranslator();
    const breakpoint = useContext(BreakpointTrackerContext);
    const isPhone = breakpoint === 'phoneWide' || breakpoint === 'phone';
    const { steps, currentStepIndex, jumpTo, stepsWithErrors, wizardTitle, wizardData } =
        wizardContext;
    let sideBarTitle = title;
    const isFnolWizard = wizardData._dtoName.indexOf('fnol') !== -1;

    if (isFnolWizard) {
        sideBarTitle = wizardTitle;
    }

    return (
        <React.Fragment>
            {!isPhone &&
                <div className={styles.wizardSidebarWrapper}>
                    <h3 className={styles.sideBarTitle}>{translator(sideBarTitle)}</h3>
                    <div role="navigation" aria-label={translator(sideBarTitle)}>
                        <ul className={styles.stepsNav}>
                            {renderSteps(
                                translator,
                                steps,
                                currentStepIndex,
                                stepsWithErrors,
                                jumpTo,
                                wizardContext,
                                isFnolWizard
                            )}
                        </ul>
                    </div>
                </div>
            }
            {
                isPhone &&
                <ul className={styles.mobileNavStep}>
                    {renderMobileSteps(
                        translator,
                        steps,
                        currentStepIndex,
                        stepsWithErrors,
                        jumpTo,
                        wizardContext,
                        isFnolWizard
                    )}
                </ul>
            }
        </React.Fragment>
    );
}

export default TFPAWizardSideMenu;